import React from 'react';
import { GroupSelector } from './selectors/GroupSelector';
import { LinkedSelectors } from './selectors/LinkedSelectors';
import { IGroupSelectorProps } from './types';

export const BaseExtendedSelector = (props: IGroupSelectorProps) => {
  const { subtype } = props;

  const Component = subtype === 'linked' ? LinkedSelectors : GroupSelector;

  return <Component {...props} />;
};
